// extracted by mini-css-extract-plugin
export default {"menuitem":"DirectMessageMenu_menuitem__7cKFu"};